import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=7afc80e1&scoped=true&"
import script from "./CustomFooter.vue?vue&type=script&lang=js&"
export * from "./CustomFooter.vue?vue&type=script&lang=js&"
import style0 from "./CustomFooter.vue?vue&type=style&index=0&id=7afc80e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc80e1",
  null
  
)

component.options.__file = "CustomFooter.vue"
export default component.exports